import { render, staticRenderFns } from "./ReceiverUpload.vue?vue&type=template&id=3129270a&"
import script from "./ReceiverUpload.vue?vue&type=script&lang=js&"
export * from "./ReceiverUpload.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports